// Meteoblue wind direction mapping
// Based on actual API responses for Meteoblue which return string values like "W", "N", "Calm", etc.
// Rather than degrees, hub api returns descriptive string values

export interface WindDirectionOption {
  value: string;
  label: string;
  shortLabel: string;
}

// Wind direction options based on actual Meteoblue API responses
export const WIND_DIRECTION_OPTIONS: WindDirectionOption[] = [
  // Primary Cardinal Directions
  { value: 'N', label: 'North (N)', shortLabel: 'N' },
  { value: 'E', label: 'East (E)', shortLabel: 'E' },
  { value: 'S', label: 'South (S)', shortLabel: 'S' },
  { value: 'W', label: 'West (W)', shortLabel: 'W' },

  // Intercardinal Directions
  { value: 'NE', label: 'Northeast (NE)', shortLabel: 'NE' },
  { value: 'SE', label: 'Southeast (SE)', shortLabel: 'SE' },
  { value: 'SW', label: 'Southwest (SW)', shortLabel: 'SW' },
  { value: 'NW', label: 'Northwest (NW)', shortLabel: 'NW' },

  // Half-wind Directions
  { value: 'NNE', label: 'North-Northeast (NNE)', shortLabel: 'NNE' },
  { value: 'ENE', label: 'East-Northeast (ENE)', shortLabel: 'ENE' },
  { value: 'ESE', label: 'East-Southeast (ESE)', shortLabel: 'ESE' },
  { value: 'SSE', label: 'South-Southeast (SSE)', shortLabel: 'SSE' },
  { value: 'SSW', label: 'South-Southwest (SSW)', shortLabel: 'SSW' },
  { value: 'WSW', label: 'West-Southwest (WSW)', shortLabel: 'WSW' },
  { value: 'WNW', label: 'West-Northwest (WNW)', shortLabel: 'WNW' },
  { value: 'NNW', label: 'North-Northwest (NNW)', shortLabel: 'NNW' },

  // Descriptive Wind Conditions
  { value: 'Unknown', label: 'Unknown', shortLabel: 'Unknown' },
  { value: 'Calm', label: 'Calm', shortLabel: 'Calm' },
  { value: 'LW', label: 'Light Winds (LW)', shortLabel: 'LW' },
  { value: 'LB', label: 'Light Breeze (LB)', shortLabel: 'LB' },
  { value: 'Windy', label: 'Windy', shortLabel: 'Windy' },
  { value: 'Breezy', label: 'Breezy', shortLabel: 'Breezy' },
  { value: 'Gusty', label: 'Gusty', shortLabel: 'Gusty' },
  { value: 'Variable Winds', label: 'Variable Winds', shortLabel: 'Variable' }
];

/**
 * Get wind direction label from string value
 * @param value - Wind direction string value (e.g., "W", "NE", "Calm")
 * @returns Formatted wind direction label
 */
export const getWindDirectionLabel = (value: string): string => {
  if (!value) return '';

  const option = WIND_DIRECTION_OPTIONS.find(opt => opt.value === value);
  return option ? option.label : value; // Return original value if not found
};

/**
 * Get short wind direction label from string value
 * @param value - Wind direction string value (e.g., "W", "NE", "Calm")
 * @returns Short wind direction label
 */
export const getWindDirectionShortLabel = (value: string): string => {
  if (!value) return '';

  const option = WIND_DIRECTION_OPTIONS.find(opt => opt.value === value);
  return option ? option.shortLabel : value; // Return original value if not found
};
